import React from 'react';
import { SignedIn, SignedOut, useClerk } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useI18n } from "../i18n/i18n";
import { useSnapshotRenderMode } from "../utils/prerender";

function InnerAuthBar() {
  const { signOut } = useClerk();
  const { t, localizePath } = useI18n();

  return (
    <div className="authBar" role="navigation" aria-label={t("auth.navLabel")}>
      <SignedOut>
        <Link to={localizePath("/sign-in")} className="authBarAction authBarAction--link">
          {t("auth.signInUp")}
        </Link>
      </SignedOut>
      <SignedIn>
        <button
          type="button"
          className="authBarAction"
          onClick={() => signOut()}
          aria-label={t("auth.logoutAria")}
          title={t("auth.logoutAria")}
        >
          {t("auth.logoutAria")}
        </button>
      </SignedIn>
    </div>
  );
}

export default function AuthBar({ enabled = true }) {
  const snapshotMode = useSnapshotRenderMode();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!enabled || snapshotMode || !isMounted) return null;
  return <InnerAuthBar />;
}
